var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { propertySetupScreenForIndicatorHandler } from '@shared/utils/AppHandlers';
import { DialogResultsStuct } from '@shared/commons/UtilsClasses/DialogResultsStuct';
import { PropertySetupScreen } from './PropertySetupScreen';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { Resources } from '@shared/localizations/Resources';
export class PropertySetupScreenForIndicator extends PropertySetupScreen {
    constructor() {
        super();
    }
    okClick() {
        const callback = this.get('callback');
        if (callback) {
            const res = new DialogResultsStuct();
            res.Data = this.arrayProperties;
            res.Button = DialogResultsStuct.CallBackInitiator.okClick;
            callback(res);
        }
        this.close(true);
    }
    closeClick() {
        const callback = this.get('callback');
        if (callback) {
            const res = new DialogResultsStuct();
            res.Button = DialogResultsStuct.CallBackInitiator.cancelClick;
            callback(res);
        }
        this.close(true);
    }
    close(fromBtn) {
        if (!fromBtn) {
            const callback = this.get('callback');
            if (callback) {
                const res = new DialogResultsStuct();
                res.Button = DialogResultsStuct.CallBackInitiator.closeClick;
                callback(res);
            }
        }
        super.close();
    }
    static editProperty(caller, callBack, headerKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(caller === null || caller === void 0 ? void 0 : caller.Properties)) {
                return;
            }
            const propScreen = caller.propertiesScreen;
            if (propScreen) {
                propScreen.gotFocus();
                return;
            }
            const scr = new PropertySetupScreenForIndicator();
            MainWindowManager.AddControl(scr);
            scr.PopulateProperties(caller.Properties());
            void scr.set({
                callback: callBack.bind(caller),
                name: scr._guid,
                header: Resources.getResource(headerKey)
            });
            scr.setOnClosedCallback(() => {
                delete caller.propertiesScreen;
                if (!isNullOrUndefined(caller.unsubscribeOnCallerClosed)) {
                    caller.unsubscribeOnCallerClosed(scr.onCallerClosed);
                }
            });
            if (!isNullOrUndefined(caller.subscribeOnCallerClosed)) {
                caller.subscribeOnCallerClosed(scr.onCallerClosed);
            }
            caller.propertiesScreen = scr;
            scr.setParentPanel(caller.chart.terceraChartPanelContext);
            scr.gotFocus();
        });
    }
    static PropertySetupScreenForIndicatorHandlerInitialize() {
        propertySetupScreenForIndicatorHandler.editProperty = PropertySetupScreenForIndicator.editProperty;
    }
}
PropertySetupScreen.extendWith(PropertySetupScreenForIndicator, {});
